export interface LevelOfCare {
  id: number;
  startDatetime: string;
  endDatetime?: any;
  createdDatetime: string;
  updatedDatetime: string;
  createdBy: string;
  updatedBy: string;
  levelOfCareType: string;
}

export interface PatientChartResponse {
  id: number;
  externalId: number;
  tenantId: number;
  teamName?: any;
  careType: string;
  patientStatus: string;
  createdDatetime: string;
  admittedDatetime: string;
  updatedDatetime: string;
  createdBy: string;
  updatedBy: string;
  riskPriority?: any;
  doNotResuscitateStatus?: any;
  dischargedReason?: any;
  levelOfCare: LevelOfCare;
}

export interface PatientResponse {
  id: number;
  firstName: string;
  middleInitial: string;
  lastName: string;
  fullName: string;
  uniqueIdentifier: string;
  nickName: string;
  birthDate: Date;
  age: number;
  emailAddress: string;
  prefix: PatientResponseDetail;
  suffix: PatientResponseDetail;
  mrn: string;
}

export interface PatientResponseDetail {
  id: number;
  description: string;
}

class PatientPatientChart implements PatientResponse {
  private _id: number;
  private _firstName: string;
  private _middleInitial: string;
  private _lastName: string;
  private _fullName: string;
  private _uniqueIdentifier: string;
  private _nickName: string;
  private _birthDate: Date;
  private _age: number;
  private _emailAddress: string;
  private _prefix: PatientResponseDetail;
  private _suffix: PatientResponseDetail;
  private _mrn: string;

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get middleInitial(): string {
    return this._middleInitial;
  }

  set middleInitial(value: string) {
    this._middleInitial = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get fullName(): string {
    return this._fullName;
  }

  set fullName(value: string) {
    this._fullName = value;
  }

  get uniqueIdentifier(): string {
    return this._uniqueIdentifier;
  }

  set uniqueIdentifier(value: string) {
    this._uniqueIdentifier = value;
  }

  get nickName(): string {
    return this._nickName;
  }

  set nickName(value: string) {
    this._nickName = value;
  }

  get birthDate(): Date {
    return this._birthDate;
  }

  set birthDate(value: Date) {
    this._birthDate = value;
  }

  get age(): number {
    return this._age;
  }

  set age(value: number) {
    this._age = value;
  }

  get emailAddress(): string {
    return this._emailAddress;
  }

  set emailAddress(value: string) {
    this._emailAddress = value;
  }

  get prefix(): PatientResponseDetail {
    return this.prefix;
  }

  set prefix(value: PatientResponseDetail) {
    this.prefix = value;
  }

  get suffix(): PatientResponseDetail {
    return this.suffix;
  }

  set suffix(value: PatientResponseDetail) {
    this.suffix = value;
  }

  get mrn(): string {
    return this._mrn;
  }

  set mrn(value: string) {
    this._mrn = value;
  }
}

export default class PatientChart implements PatientChartResponse {
  static PATIENT_CHART_STATUS_EVALUATION = "evaluation";
  static PATIENT_CHART_STATUS_REFERRAL = "referral";
  static PATIENT_CHART_STATUS_ON_SERVICE = "on-service";
  static PATIENT_CHART_STATUS_DISCHARGED = "discharged";
  static PATIENT_CHART_STATUS_CANCELLED = "cancelled";

  private _careType: string;
  private _createdBy: string;
  private _createdDatetime: string;
  private _admittedDatetime: string;
  private _externalId: number;
  private _id: number;
  private _levelOfCare: LevelOfCare;
  private _patientStatus: string;
  private _tenantId: number;
  private _updatedBy: string;
  private _updatedDatetime: string;
  private _dischargedReason: string;
  private _dischargedDatetime: string;

  private _patient: PatientResponse;

  get patient(): PatientResponse {
    return this._patient;
  }

  set patient(value: PatientResponse) {
    this._patient = value;
  }

  get careType(): string {
    return this._careType;
  }

  set careType(value: string) {
    this._careType = value;
  }

  get createdBy(): string {
    return this._createdBy;
  }

  set createdBy(value: string) {
    this._createdBy = value;
  }

  get createdDatetime(): string {
    return this._createdDatetime;
  }

  get admittedDatetime(): string {
    return this._admittedDatetime;
  }

  set createdDatetime(value: string) {
    this._createdDatetime = value;
  }

  set admittedDatetime(value: string) {
    this._admittedDatetime = value;
  }

  get externalId(): number {
    return this._externalId;
  }

  set externalId(value: number) {
    this._externalId = value;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get levelOfCare(): LevelOfCare {
    return this._levelOfCare;
  }

  set levelOfCare(value: LevelOfCare) {
    this._levelOfCare = value;
  }

  get patientStatus(): string {
    return this._patientStatus;
  }

  set patientStatus(value: string) {
    this._patientStatus = value;
  }

  get tenantId(): number {
    return this._tenantId;
  }

  set tenantId(value: number) {
    this._tenantId = value;
  }

  get updatedBy(): string {
    return this._updatedBy;
  }

  set updatedBy(value: string) {
    this._updatedBy = value;
  }

  get updatedDatetime(): string {
    return this._updatedDatetime;
  }

  set updatedDatetime(value: string) {
    this._updatedDatetime = value;
  }

  get dischargedReason(): string {
    return this._dischargedReason;
  }

  set dischargedReason(value: string) {
    this._dischargedReason = value;
  }

  get dischargedDatetime(): string {
    return this._dischargedDatetime;
  }

  set dischargedDatetime(value: string) {
    this._dischargedDatetime = value;
  }
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/patientChartResponse.ts